import React, { Fragment } from "react";
import { RouteName, RouteParams } from "../../lib/routes";
import TopBox from "../common/TopBox";
import { ApiResult } from "../../lib/CmsApi";
import { format } from "date-fns";
import DefaultSectionListWithNav, {
  flattenCMSSectionLists
} from "../sections/SectionListWithNav";
import { colors } from "../theme";
import { AriaDate, slug } from "../../lib/formatters";
import DownloadSection from "../sections/Downloads";
import styled from "styled-components";
import {
  StickyNav,
  extractLinksFromSections
} from "../sections/SectionListWithNav/StickyNav";

const Navigable = styled.div`
  position: relative;
`;
const SectionListWithNav = styled(DefaultSectionListWithNav)`
  h1,
  h2 {
    color: ${colors.darkgrey};
  }
`;
export type Props = ApiResult<"loadPressReleaseBySlug">;

export default function PressReleasePage(props: Props) {
  const cmsSections = flattenCMSSectionLists(props.sections);
  const downloadLink = {
    navLink: "Downloads",
    id: slug("Downloads")
  };
  return (
    <Fragment>
      <TopBox
        breadCrumpPath={
          [
            {
              route: "press",
              title: "Presse"
            },
            {
              title: props.title,
              route: "pressRelease",
              params: {
                slug: props.slug
              }
            }
          ] as { title: string; route: RouteName; params: RouteParams }[]
        }
        title={props.title}
        overline={
          <>
            <AriaDate date={props.date} />
            {" | Pressemitteilung"}
          </>
        }
        linearBackground
      />
      <Navigable>
        <StickyNav
          links={[
            ...extractLinksFromSections(cmsSections),
            props.documents && !!props.documents.length && downloadLink
          ]}
        />
        {cmsSections && !!cmsSections.length && (
          <SectionListWithNav
            limitContentWidth
            sections={cmsSections}
            noNavRender
          />
        )}
        <aside aria-label="Zugehörige Downloads">
          <DownloadSection
            sectionProps={{
              id: downloadLink.id,
              leftIndented: true,
              reducedSectionPadding: true,
              color: colors.paleGrey
            }}
            headline="Downloads"
            documents={props.documents as any}
          />
        </aside>
      </Navigable>
    </Fragment>
  );
} //TODO: Fix any

PressReleasePage.getImages = (p: Props) => {
  let images = [];

  const sections = flattenCMSSectionLists(p.sections);
  images = images.concat(DefaultSectionListWithNav.getImages({ sections }));
  return images;
};
